module.exports = __webpack_public_path__ + "img/tank-truck.afcb7dde.png";